import type { ApiRoute, NoBody, NoQueryParams } from "../api"
import type { InventoryInformationEditView } from "./InventoryInformationEditView"

export interface GetInventoryEditViewPathParams {
	inventoryId: string
}

export const getInventoryInformationEditViewRoute: ApiRoute<
	GetInventoryEditViewPathParams,
	NoQueryParams,
	NoBody,
	InventoryInformationEditView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/inventory-information-edit`,
	method: "get",
	path: "/vehicles/:inventoryId/inventory-information-edit",
}
